import styles from "./loading-content.module.scss";

function LoadingContent() {
  // Having 3 empty divs there was needed by the css
  return (
    <>
      <h1 className={styles.heading}>Loading</h1>
      <div className={styles.loadingBlocks}>
        <div />
        <div />
        <div />
      </div>
    </>
  );
}

export default LoadingContent;
